.c0{position:absolute;}